//ORDER IS IMPORTANT
import "Validation/yup/methods";

import "Styles/UIKit/uikit.scss";
import * as React from "react";
import { CookiesProvider } from "react-cookie";
import { Provider } from "react-redux";
import { LayoutContextProvider } from "Components/LayoutContext";

declare module "react-redux" {
   interface DefaultRootState extends LSStore.State {

   }
}

export const PageBase: React.FC = function ({ children }) {
   return (
      <Provider store={LSStore.instance}>
         <LayoutContextProvider>
            <CookiesProvider>
               {children}
            </CookiesProvider>
         </LayoutContextProvider>
      </Provider>
   );
}